import { modules } from 'veritone-redux-common';

const { config: { getConfig }, user } = modules;

export const initSegment = (state, page) => {
  const analytics = (window.analytics = window.analytics || []);
  if (!analytics.initialize && !analytics.invoked) {
    analytics.invoked = !0;
    analytics.methods = [
      'trackSubmit',
      'trackClick',
      'trackLink',
      'trackForm',
      'pageview',
      'identify',
      'reset',
      'group',
      'track',
      'ready',
      'alias',
      'debug',
      'page',
      'once',
      'off',
      'on'
    ];
    analytics.factory = function(t) {
      return function() {
        let e = Array.prototype.slice.call(arguments);
        e.unshift(t);
        analytics.push(e);
        return analytics;
      };
    };
    for (let t = 0; t < analytics.methods.length; t++) {
      let e = analytics.methods[t];
      analytics[e] = analytics.factory(e);
    }
    analytics.load = t => {
      const e = document.createElement('script');
      e.type = 'text/javascript';
      e.async = !0;
      e.src = `${document.location.protocol === 'https:'
        ? 'https://'
        : 'https://'}cdn.segment.com/analytics.js/v1/${t}/analytics.min.js`;
      const n = document.getElementsByTagName('script')[0];
      n.parentNode.insertBefore(e, n);
    };
    analytics.SNIPPET_VERSION = '4.1.0';
    analytics.load(getConfig(state).segmentIoKey);
    analytics.page(page);

    const currentUser = user.selectUser(state);
    analytics.identify(`${currentUser.userId}`, {
      email: currentUser.userName,
      'VTN-Developer': 'True'
    });
  }
  return analytics;
};



// WEBPACK FOOTER //
// ./src/client/helpers/analyticsHelper.js